package com.fireavert.react.pages.administration.breadcrumbs.users

import UserDialogMode
import com.fireavert.menu.menu_navigation.client.AdministrationPagePaths
import com.fireavert.react.auth.PermissionRequired
import com.fireavert.react.pages.administration.breadcrumbs.users.dialogs.AddNewUserDialog
import com.fireavert.react.shared.LoggedIn
import com.fireavert.react.shared.components.nav.NavOption
import com.fireavert.react.shared.components.nav.SideNavV2
import com.fireavert.react.shared.components.nav.TopNavBarV2
import com.fireavert.react.shared.styles.PageStyles
import com.fireavert.react.shared.styles.PageStylesV2
import com.fireavert.user.data_models.Permission
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.useNavigate
import react.useEffect
import react.useState

external interface AdminUserPageProps : Props {
    var addNewUserDialogIsOpen: Boolean
    var editUserDialogIsOpen: Boolean
}
val AdminUserPage = FC<AdminUserPageProps> { props ->
    val navigate = useNavigate()
    var isAddNewUserDialogOpen by useState(props.addNewUserDialogIsOpen)
    var isEditUserDialogOpen by useState(props.editUserDialogIsOpen)

    // Update state when props change
    useEffect(props.addNewUserDialogIsOpen, props.editUserDialogIsOpen) {
        isAddNewUserDialogOpen = props.addNewUserDialogIsOpen
        isEditUserDialogOpen = props.editUserDialogIsOpen
    }
    LoggedIn {}
    if (isAddNewUserDialogOpen) {
        AddNewUserDialog {
            mode = UserDialogMode.CREATE
            closeDialog = {
                isAddNewUserDialogOpen = false
                navigate("${AdministrationPagePaths.userPage}/all")
            }
        }
    }
    else if (isEditUserDialogOpen) {
        AddNewUserDialog {
            mode = UserDialogMode.EDIT
            closeDialog = {
                isEditUserDialogOpen = false
                navigate("${AdministrationPagePaths.userPage}/all")
            }
        }
    }
    ReactHTML.div {
        className = PageStyles.flexContainer
        SideNavV2 {
            activeNavOption = NavOption.Administration
        }
        PermissionRequired {
            permission = Permission.ViewUserList
            ReactHTML.div {
                className = PageStylesV2.mainContainer
                TopNavBarV2 { activeNavOption = NavOption.Administration }
                ReactHTML.div {
                    className = PageStylesV2.mainContainerContent
                    UserSection {
                        isUserDialogOpen = false
                    }
                }
            }
        }
    }
}